export interface PersonalBackgroundFormDataGeneric {
  id: number;
  name: string;
}
export interface PersonalBackgroundFormDataResponse {
  photo?: string;
  countries: PersonalBackgroundFormDataGeneric[];
  genders: PersonalBackgroundFormDataGeneric[];
  maritalStatus: PersonalBackgroundFormDataGeneric[];
  regions: PersonalBackgroundFormDataGeneric[];
  cities: PersonalBackgroundFormDataGeneric[];
  communes: { id: number; name: string; regionId: number }[];
  areaTypes: { id: number; name: string }[];
  teacherAcademicRanks: { id: number; name: string }[];
  normalizedPositions: { id: string; name: string }[];
  teacherOCDEAcademicRanks: { id: string; name: string }[];
  healthSystems: PersonalBackgroundFormDataGeneric[];
  healthInstitutions: PersonalBackgroundFormDataGeneric[];
  responses: Record<string, any>;
  identificationTypes: PersonalBackgroundFormDataGeneric[];
  tenanCountry: PersonalBackgroundFormDataGeneric;
  campuses: PersonalBackgroundFormDataGeneric[];
  schools: PersonalBackgroundFormDataGeneric[];
}

export enum healthSystemsCodes {
  Private = 'PV', // en chile equivalente a isapre
  Public = 'PU', // en chile equivalente a fonasa
  Mixed = 'MI', // en chile equivalente fuerzas armadas u otro sistema mixto
}
